import React from 'react';
import Popover from 'housecall-ui/dist/DesignSystem/DataDisplay/Popover/Popover';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import WarningIcon from 'housecall-ui/dist/IconsAndImages/Icons/Warning';

type Props = {
  disabled?: boolean;
  children: React.ReactNode;
  onClick: () => void;
  warningMessage?: React.ReactNode;
};

const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    padding: theme.spacing(1),
  },
}));

export default function PayWallSubmitButton(props: Props): JSX.Element {
  const { disabled, onClick, children, warningMessage = null } = props;

  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  let buttonIcon = null;

  if (warningMessage) {
    buttonIcon = <WarningIcon data-testid="paywall-submit-button__warning-icon" />;
  }

  return (
    <>
      <Button
        variant="contained"
        disabled={disabled}
        color="primary"
        onClick={onClick}
        data-testid="paywall-submit-button"
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        endIcon={buttonIcon}
      >
        {children}
      </Button>
      <Popover
        id="mouse-over-popover"
        data-testid="paywall-submit-button__popover"
        open={!!warningMessage && open}
        anchorEl={anchorEl}
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        {warningMessage}
      </Popover>
    </>
  );
}
